module.exports = __webpack_public_path__ + "static/media/think.b3f65964.svg";